export default "/images/framework/ForwardNoShadow.0cb02de4.svg?0cb02de4";